<template>
  <div id="chemicalModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="chemicalModalLabel1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="exampleModalLabel1" class="modal-title">
            Add New Chemical
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" @submit.prevent="handleSubmit">
            <div class="card-body card-blue">
              <div class="form-group row">
                <label for="name" class="col-sm-3 text-right control-label col-form-label">Name</label>
                <div class="col-sm-9">
                  <input id="name" v-model="chemical.name" v-validate="'required'" type="text" class="form-control" name="name" placeholder="Name" data-vv-as="Name" :class="{'is-invalid': submitted && errors.has('name')}">
                  <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                    {{ errors.first('name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="brand" class="col-sm-3 text-right control-label col-form-label">Brand</label>
                <div class="col-sm-9">
                  <input id="brand" v-model="chemical.brand" v-validate="'required'" type="text" class="form-control" name="brand" placeholder="Brand" data-vv-as="Brand" :class="{'is-invalid': submitted && errors.has('brand')}">
                  <div v-if="submitted && errors.has('brand')" class="invalid-feedback">
                    {{ errors.first('brand') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="amount" class="col-sm-3 text-right control-label col-form-label">Amount</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <input id="amount" v-model="chemical.amount" v-validate="'required'" type="text" class="form-control" name="amount" placeholder="Amount" data-vv-as="Amount" :class="{'is-invalid': submitted && (errors.has('amount') || errors.has('units'))}">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{ chemical.amount_units }}
                      </button>
                      <div class="dropdown-menu" x-placement="bottom-start">
                        <a v-for="(unit,index) in unitList" :key="index" class="dropdown-item" @click="setAmountUnits(unit.value)">{{ unit.text }}</a>
                      </div>
                    </div>
                    <div v-if="submitted && errors.has('amount')" class="invalid-feedback">
                      {{ errors.first('amount') }}
                    </div>
                    <div v-if="submitted && errors.has('amount_units')" class="invalid-feedback">
                      {{ errors.first('amount_units') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="price_amount" class="col-sm-3 text-right control-label col-form-label">Price (USD)</label>
                <div class="col-sm-9">
                  <input id="price_amount" v-model="chemical.price_amount" v-validate="'required'" type="text" class="form-control" name="price_amount" placeholder="Price" data-vv-as="Price" :class="{'is-invalid': submitted && errors.has('price_amount')}">
                  <div v-if="submitted && errors.has('price_amount')" class="invalid-feedback">
                    {{ errors.first('price_amount') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="price_amount" class="col-sm-3 text-right control-label col-form-label">Year</label>
                <div class="col-sm-9">
                  <select id="year" v-model="year" class="form-control" name="year">
                    <option v-for="(year,index) in yearList" :key="index" :value="year">
                      {{ year }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn waves-effect waves-light btn-success">
                Save
              </button>
              <button type="button" class="btn waves-effect waves-light btn-secondary" @click="reset()">
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChemicalModal',
  data () {
    return {
      submitted: false,
      props: ['propYear'],
      chemical: {
        amount: '',
        amount_units: 'Select Unit',
        name: '',
        price_amount: '',
        price_units: 'USD',
        brand: ''
      },
      yearList: [],
      year: (new Date()).getFullYear(),
      unitList: [
        { value: 'EA', text: 'Each' },
        { value: 'BU', text: 'Bushels' },
        { value: 'KG', text: 'Kilograms' },
        { value: 'T', text: 'Tons' },
        { value: 'LBS', text: 'Pounds' },
        { value: 'MT', text: 'Metric Tons' },
        { value: 'L', text: 'Liters' },
        { value: 'ml', text: 'milli liters' }
      ]
    }
  },
  mounted () {
    // console.log(this.propYear);
    if (this.propYear !== undefined) {
      this.year = this.propYear
    }
    const currentYear = (new Date()).getFullYear()
    this.yearList = []
    for (var i = 0; i < 5; i++) {
      this.yearList.push(parseInt(currentYear) + i)
    }
  },
  methods: {
    setAmountUnits (amount_units) {
      this.chemical.amount_units = amount_units
    },
    handleSubmit () {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save()
          }
        })
    },
    async save () {
      await this.$api.put('/growers/inputs/chemical', this.chemical, {
        params: {
          year: this.year
        }
      })
      this.$toastr('success', 'New chemical added successfully.', 'Chemical Saved')
      this.$parent.year = this.year
      this.$parent.getInputList()
      this.reset()
      $('#chemicalModal').modal('toggle')
    },
    reset () {
      this.submitted = false
      this.chemical = {
        amount: '',
        amount_units: 'Select Unit',
        name: '',
        price_amount: '',
        price_units: 'USD',
        brand: ''
      }
    }
  }
}
</script>

<style scoped>
</style>
